import { Component, Vue } from 'vue-property-decorator';
import CurrentSubscription from '@/components/current-subscription';
import Invoices from '@/components/invoices';

import template from './subscription.vue';

@Component({
  mixins: [template],
  components: {
    CurrentSubscription,
    Invoices
  },
})
export default class Profile extends Vue {
}